import { useEffect } from "react";
//redux salarycalculationYear1
import {
  getSurplusBeforeTaxYear1,
  getTemplatePayrollTaxYear1,
  getFixedEarnedIncomeYear1,
  getTaxableIncomeYear1,
  getLocalTaxesYear1,
  getStateTaxYear1,
  getPayrollTaxYear1,
  getGeneralPensionYear1,
  getFuneralFeesYear1,
  getReductionOfGeneralPensionYear1,
  getEarnedIncomeTaxYear1,
  getNetProfitPerYearYear1,
  getNetProfitPerMonthYear1,
  getGeneralPayrollTaxYear1,
  getGrossAnnualSalaryYear1,
} from "../Redux/Actions/salarycalculationYear1";

export const CalculationYear1 = (
  dispatch,
  calculating,
  templatePayrollPercent,
  standardTaxRelief,
  localTaxesPercent,
  payrollTaxPercent,
  generalPensionPercent,
  generalPensionCutOffValue,
  funeralFeesPercent,
  earnedIncomeTaxCutOffValue,
  earnedIncomeTaxPercent,
  generalPayrollTaxPercent,
  activeCompany,
  activeYear,
  totalFixedCost,
  totalYearGrossMargin,
  totalMeasuredCostsPerYear,
  nonTaxableIncomeLimit,
  stateTaxCutOfValue,
  stateTaxPercent,
  totalYearGrossMarginPerYear,
  totalFixedCostPerYear,
  salaryCalculationData,
  setCalculating
) => {
  //#region calculations to get monthly salary in dashboard year1
  let companyFormYear1 = "";

  salaryCalculationData?.map(
    (item) => (companyFormYear1 = item.object.activeCompany.companyFormYear1)
  );

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      function calculationsYear1() {
        const resultSurplus =
          totalYearGrossMarginPerYear.year1 -
          totalFixedCostPerYear.year1 -
          totalMeasuredCostsPerYear.year1;
        if (resultSurplus === 0) {
          dispatch(getSurplusBeforeTaxYear1(0));
        } else {
          resultSurplus && dispatch(getSurplusBeforeTaxYear1(resultSurplus));
        }

        //get template payroll tax (egenavgifter schablon)
        let resultTemplatePayrollTax =
          (templatePayrollPercent / 100) * resultSurplus;
        if (resultSurplus <= 0) {
          resultTemplatePayrollTax = 0;
          dispatch(getTemplatePayrollTaxYear1(0));
        } else {
          resultTemplatePayrollTax &&
            dispatch(getTemplatePayrollTaxYear1(resultTemplatePayrollTax));
        }
        //#region CompanyForm in "Aktiebolag"
        //get General payroll tax (arbetsgivaravgift)
        let resultGeneralPayrollTax =
          (generalPayrollTaxPercent / 100) * resultSurplus;
        if (resultSurplus <= 0) {
          resultGeneralPayrollTax = 0;
          dispatch(getGeneralPayrollTaxYear1(0));
        } else {
          resultGeneralPayrollTax &&
            dispatch(getGeneralPayrollTaxYear1(resultGeneralPayrollTax));
        }

        //get gross year salary (Årslön brutto)
        let resultGrossAnnualSalary = resultSurplus - resultGeneralPayrollTax;
        if (resultSurplus <= 0) {
          resultGrossAnnualSalary = 0;
          dispatch(getGrossAnnualSalaryYear1(0));
        } else {
          resultGrossAnnualSalary &&
            dispatch(getGrossAnnualSalaryYear1(resultGrossAnnualSalary));
        }

        //get taxBase ("skatteunderlag" (Anders excel)
        let taxBase = resultGrossAnnualSalary + standardTaxRelief;
        if (resultGrossAnnualSalary <= nonTaxableIncomeLimit) {
          taxBase = 0;
        }
        //#endregion CompanyForm in "Aktiebolag"

        //get fixed earned income (fastställd förvärvsinkomst)
        let resultFixedEarnedIncome = resultSurplus - resultTemplatePayrollTax;
        if (resultSurplus <= 0) {
          resultFixedEarnedIncome = 0;
          dispatch(getFixedEarnedIncomeYear1(0));
        } else {
          resultFixedEarnedIncome &&
            dispatch(getFixedEarnedIncomeYear1(resultFixedEarnedIncome));
        }

        //get taxable income (beskattningsbar inkomst)
        let resultTaxableIncome = resultFixedEarnedIncome + standardTaxRelief;
        if (companyFormYear1 === "aktiebolag") {
          resultTaxableIncome = taxBase;
        }
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn. Cut off point salarycalculation stops. else standardtaxRelief is drawn
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultTaxableIncome = 0;
          dispatch(getTaxableIncomeYear1(0));
        } else {
          resultTaxableIncome &&
            dispatch(getTaxableIncomeYear1(resultTaxableIncome));
        }

        //get local taxes (kommunalskatt)
        let resultLocalTaxes = (localTaxesPercent / 100) * resultTaxableIncome;
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultLocalTaxes = 0;
          dispatch(getLocalTaxesYear1(0));
        } else {
          resultLocalTaxes && dispatch(getLocalTaxesYear1(resultLocalTaxes));
        }

        //get state tax (statlig skatt)
        let resultStateTax =
          (stateTaxPercent / 100) * (resultTaxableIncome - stateTaxCutOfValue);
        //if resultStateTax is less than the cut off value no state tax will be drawn.
        if (resultStateTax <= 0) {
          resultStateTax = 0;
          dispatch(getStateTaxYear1(0));
        } else {
          resultStateTax && dispatch(getStateTaxYear1(resultStateTax));
        }
        //egenavgifter
        let resultPayrollTax =
          (payrollTaxPercent / 100) * resultFixedEarnedIncome;
        if (resultPayrollTax === 0) {
          dispatch(getPayrollTaxYear1(0));
        } else {
          resultPayrollTax && dispatch(getPayrollTaxYear1(resultPayrollTax));
        }

        //get general pension (allmän pension)
        let resultGeneralPension =
          (generalPensionPercent / 100) * resultTaxableIncome;
        //if resultGeneralPension is more than the max cut off value max cut off value will be drawn.
        if (resultGeneralPension > generalPensionCutOffValue) {
          resultGeneralPension &&
            dispatch(getGeneralPensionYear1(generalPensionCutOffValue));
          resultGeneralPension = generalPensionCutOffValue;
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultGeneralPension = 0;
          dispatch(getGeneralPensionYear1(0));
        }
        //if resultGeneralPension is between cut off value and nonTaxable limit, pension will be drawn.
        else {
          resultGeneralPension &&
            dispatch(getGeneralPensionYear1(resultGeneralPension));
        }
        //get funeral fees (kyrko och begravningsavgift)
        let resultFuneralFees =
          (funeralFeesPercent / 100) * resultTaxableIncome;
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultFuneralFees = 0;
          dispatch(getFuneralFeesYear1(0));
        } else {
          resultFuneralFees && dispatch(getFuneralFeesYear1(resultFuneralFees));
        }
        //get reduction of general pension(skattereduktion för allmän pension)
        //resultReductionOfGeneralPension mirrors resultGeneralPension and same amount drawn will be returned
        let resultReductionOfGeneralPension = resultGeneralPension;
        if (resultReductionOfGeneralPension > generalPensionCutOffValue) {
          resultReductionOfGeneralPension &&
            dispatch(
              getReductionOfGeneralPensionYear1(generalPensionCutOffValue)
            );
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn or returned.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultReductionOfGeneralPension = 0;
          dispatch(getReductionOfGeneralPensionYear1(0));
        } else {
          resultReductionOfGeneralPension &&
            dispatch(
              getReductionOfGeneralPensionYear1(resultReductionOfGeneralPension)
            );
        }
        //get earned income (jobbskatteavdrag)
        let resultEarnedIncomeTax =
          (earnedIncomeTaxPercent / 100) * resultTaxableIncome;
        //if resultEarnedIncomeTax is more than max cut off value, max cut off value will be returned
        if (resultEarnedIncomeTax > earnedIncomeTaxCutOffValue) {
          resultEarnedIncomeTax &&
            dispatch(getEarnedIncomeTaxYear1(earnedIncomeTaxCutOffValue));
          resultEarnedIncomeTax = earnedIncomeTaxCutOffValue;
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultEarnedIncomeTax = 0;
          dispatch(getEarnedIncomeTaxYear1(0));
        } else {
          //if resultEarnedIncome is less than max cut of value but more than non taxable limit earnedIncometax will be returned.
          resultEarnedIncomeTax &&
            dispatch(getEarnedIncomeTaxYear1(resultEarnedIncomeTax));
        }

        if (companyFormYear1 === "enskildFirma") {
          let resultNetProfitPerYear =
            resultSurplus -
            resultLocalTaxes -
            resultStateTax -
            resultPayrollTax -
            resultGeneralPension -
            resultFuneralFees +
            resultReductionOfGeneralPension +
            resultEarnedIncomeTax;
          if (resultNetProfitPerYear === 0) {
            dispatch(getNetProfitPerYearYear1(0));
          }
          // if resultFixedEarnedIncome is less than the nontaxable limit no tax will be drawn but resultpayrolltax is always drawn
          else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
            resultNetProfitPerYear = resultFixedEarnedIncome - resultPayrollTax;
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear1(resultNetProfitPerYear));
          } else {
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear1(resultNetProfitPerYear));
          }

          //get net profit per month(månadslön netto)
          const resultNetProfitPerMonth = resultNetProfitPerYear / 12;
          if (resultNetProfitPerMonth === 0) {
            dispatch(getNetProfitPerMonthYear1(0));
          } else {
            resultNetProfitPerMonth &&
              dispatch(getNetProfitPerMonthYear1(resultNetProfitPerMonth));
          }
        } else if (companyFormYear1 === "aktiebolag") {
          let resultNetProfitPerYear =
            taxBase -
            resultLocalTaxes -
            resultGeneralPension -
            resultFuneralFees +
            resultReductionOfGeneralPension +
            resultEarnedIncomeTax -
            resultStateTax;
          if (resultNetProfitPerYear === 0) {
            dispatch(getNetProfitPerYearYear1(0));
          } else if (taxBase <= nonTaxableIncomeLimit) {
            resultNetProfitPerYear = resultGrossAnnualSalary;
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear1(resultGrossAnnualSalary));
          } else {
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear1(resultNetProfitPerYear));
          }
          //get net profit per month(månadslön netto)
          const resultNetProfitPerMonth = resultNetProfitPerYear / 12;
          if (resultNetProfitPerMonth === 0) {
            dispatch(getNetProfitPerMonthYear1(0));
          } else {
            resultNetProfitPerMonth &&
              dispatch(getNetProfitPerMonthYear1(resultNetProfitPerMonth));
          }
        }
      }
      calculationsYear1();
      //give time for calculations() to calculate usong calculating hook
      const delay = setTimeout(() => {
        setCalculating(true);
      }, 700);
      return () => clearTimeout(delay);
    }
    return () => {
      isMounted = false;
    };
  }, [
    dispatch,
    calculating,
    templatePayrollPercent,
    standardTaxRelief,
    localTaxesPercent,
    payrollTaxPercent,
    generalPensionPercent,
    generalPensionCutOffValue,
    funeralFeesPercent,
    earnedIncomeTaxCutOffValue,
    earnedIncomeTaxPercent,
    generalPayrollTaxPercent,
    activeCompany,
    activeYear.year,
    totalFixedCost,
    totalYearGrossMargin,
    totalMeasuredCostsPerYear,
    nonTaxableIncomeLimit,
    stateTaxCutOfValue,
    stateTaxPercent,
    totalYearGrossMarginPerYear.year1,
    totalFixedCostPerYear.year1,
    salaryCalculationData,
    companyFormYear1,
    setCalculating,
  ]);
  //#endregion calculations to get monthly salary in dashboard year1
};
